export const SHIP_TO_SUPPLY_LIMIT_DRAWER_ID = "SHIP_TO_SUPPLY_LIMIT_DRAWER";
